// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"18952":"7d23a25f4cb98d153b82","25825":"631225b24472fc5c7217","80020":"c4cf98c11573e23c1e34"}[chunkId] + ".css";
};